import { Component, Input, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { FileUploadService } from 'src/app/services/file-upload/file-upload.service';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { CompletionQuestionsService } from 'src/app/services/completion-questions/completion-questions.service';
import { mimeType } from '../mime-type.validator';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingSpinnerComponent } from '../../../shared/loading-spinner/loading-spinner.component';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-add-file-upload',
  templateUrl: './add-file-upload.component.html',
  styleUrls: ['./add-file-upload.component.css'],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    LoadingSpinnerComponent,
  ],
})
export class AddFileUploadComponent implements OnInit {
  form!: FormGroup;
  imagePreview: string = '';
  addState: boolean = false;
  error!: string | null;
  isLoading: boolean = false;
  constructor(
    private fileService: FileUploadService,
    private dropdownService: DropdownService,
    private completionQuestionsService: CompletionQuestionsService
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      title: new FormControl(null, {
        validators: [Validators.required],
      }),
      isSafe: new FormControl(null, {
        validators: [Validators.required],
      }),
      file: new FormControl(null, {
        validators: [Validators.required],
        asyncValidators: [mimeType],
      }),
    });
  }

  onImagePicked(event: Event) {
    let inputElement: HTMLInputElement = event.target as HTMLInputElement;
    if (!inputElement) return;

    let fileList: FileList | null = inputElement.files;
    if (!fileList) return;

    if (fileList.length < 1) return;

    const file = fileList[0];
    this.form.patchValue({ file: file });
    let getFile: AbstractControl = this.form.get('file') as AbstractControl;
    if (!getFile) return;

    getFile.updateValueAndValidity();
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
    reader.readAsDataURL(file);
    console.log(this.imagePreview);
  }

  onSaveImage(): void {
    this.error = null;
    
    // Mark all form controls as touched to trigger validation display
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsTouched();
    });
    
    if (this.form.invalid) {
      this.isLoading = false;
      this.error = 'Fill in all fields and select image';
      return;
    }
    
    this.isLoading = true;
    console.log(this.form.value);
    
    this.fileService
      .addFile(
        this.form.value.title,
        this.form.value.isSafe,
        this.form.value.file,
      )
      .pipe(
        // First update the completion question
        switchMap(() => this.completionQuestionsService.updateCompletionQuestion(45, true)),
        // Then refresh the page completion statuses
        tap(() => {
          this.dropdownService.setPageCompletionStatuses();
        })
      )
      .subscribe({
        next: () => {
          this.addState = !this.addState;
          this.isLoading = false;
          this.form.reset();
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error uploading photo:', error);
        }
      });
  }

  change() {
    this.addState = !this.addState;
  }

  onClose() {
    this.error = null;
  }
}
